import { TargetedMessagesTypePath, type TargetedMessagesRoutes } from 'constants/targeted-messages';
import { TargetedMessageSubtype } from 'store/entities/greetings/interfaces';

// Valid values for TargetedMessagesTypePath enum for runtime validation
const validTargetedMessageTypes: readonly string[] = [
  TargetedMessagesTypePath.Greetings,
  TargetedMessagesTypePath.Announcements,
] as const;

export function mapTargetedMessageTypeToRoute(
  targetedMessageType: TargetedMessagesTypePath,
  route: TargetedMessagesRoutes,
): string {
  // Validate that targetedMessageType matches known enum values to prevent XSS
  if (!validTargetedMessageTypes.includes(targetedMessageType)) {
    throw new Error('Invalid targetedMessageType for route');
  }

  return route.replace(':targetedMessageType', encodeURIComponent(targetedMessageType));
}

export const mapTargetedMessageSubtypeToPathType = (
  targetedMessageSubtype: TargetedMessageSubtype,
): TargetedMessagesTypePath =>
  ({
    [TargetedMessageSubtype.Greeting]: TargetedMessagesTypePath.Greetings,
    [TargetedMessageSubtype.Announcement]: TargetedMessagesTypePath.Announcements,
  })[targetedMessageSubtype];
